import { connect } from 'react-redux'
import LayerGroup from '../../components/olComponents/layerGroup'
import { getToken } from '../../userStoredData'

const mapStateToProps = state => ({
  token: getToken()
})

export default connect(mapStateToProps)(LayerGroup)
